/**
 * A generic class which handles a null error
 * */
export class NullHTMLElementError extends Error {
  /**
   * The id of the inexistant HTMLElement
   */
  constructor(id) {
    super("There is no HTMLElement with the following id: ".concat(id));
  }
  /**
   * Checks if the element with the given id exists or not
   */
  static CheckNullHTMLElementError(id) {
    var elem = document.getElementById(id);
    if (!elem) throw new NullHTMLElementError(id);else return elem;
  }
}